import React from 'react';
import moment from 'moment';
import { Accordion, AccordionTab } from 'primereact/accordion';
const NewsUpdates = (props) => {
    return (
        <>
            {props.data && props.data.length > 0 ? 
            <Accordion>
                {props.data.map((tab, index) =>
                    <AccordionTab key={index} header={`Announcement by ${tab.createdBy} on ${moment(tab.createdDate).format('DD/MM/YYYY')}`} >
                        <div dangerouslySetInnerHTML={{ __html: tab.newsContent }} />
                    </AccordionTab>)}
            </Accordion> : <div>
                    No News Found.
            </div>}
        </>
    );
}

export default NewsUpdates;